import { type InputHTMLAttributes, useState } from 'react';
import { t } from '../../i18n';

/**
 * `.input` is applied two hundred and twenty-seven times. This does not try to
 * replace all of them — a bare `<input className="input">` is already one
 * short line. What it replaces is the one input that was genuinely copied:
 * the password field with the Show/Hide affordance, written out identically in
 * Signin, OwnerLogin and StaffLogin, down to the `tabIndex={-1}`.
 */
export function inputClass(className = ''): string {
  return className ? `input ${className}` : 'input';
}

export function PasswordInput({
  className = '',
  bare = false,
  ...rest
}: InputHTMLAttributes<HTMLInputElement> & {
  /** Skip `.input` entirely. The sign-in screens carry his own 64px field,
   *  and layering the old component class under it leaves two paddings and
   *  two backgrounds fighting for the same box. */
  bare?: boolean;
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        {...rest}
        type={show ? 'text' : 'password'}
        className={bare ? `pe-12 ${className}`.trim() : inputClass(`pe-12 ${className}`.trim())}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        className="absolute end-2 top-1/2 -translate-y-1/2 text-xs text-muted-foreground hover:text-foreground px-2 py-1"
        tabIndex={-1}
      >
        {show ? t('Hide') : t('Show')}
      </button>
    </div>
  );
}
